module.exports = __webpack_public_path__ + "media/images/youtube-podcast-235fe1a804a96dc37be23d6e19fed269.jpg";